import React, { useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'
import { Settings } from 'media/icons'
import styled from 'styled-components'
import { withRouter } from 'react-router'
import { NavBarItem } from 'components/NavBar'
import { StyledNavBarItem } from 'components/NavBar/styled'

const OptionenNavConteiner = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	position: relative;
	cursor: ${props => props.isDisabled ? 'not-allowed' : 'pointer'};
	${({ isMatched, theme }) => isMatched && `
		color: ${theme.activeColor};
		font-weight: 400;
		g {
			fill: ${theme.activeColor}
		}
	`}
`

const NavDropDown = styled.div`
	position: absolute;
	top: 100%;
	right: 0;
	width: 211px;
	z-index: 100;
	background-color: ${props => props.theme.primaryHover};
	padding: 5px 20px;

	${StyledNavBarItem} {
		font-size: 12px;
	}

	a, span, div {
		height: 32px;
		justify-content: flex-start;
		pointer-events: unset !important;

		&:hover {
			color: ${props => props.theme.activeColor};
		}
	}
`

const NavComponent = ({ navItemRef, location, isDisabled }) => {
	const isMatched = location.pathname.startsWith('/optionen')
	const [displayDropdown, setDisplayDropdown] = useState(false)
	const dropDownCloseTimer = useRef()
	const [t] = useTranslation()

	/* eslint-disable react-hooks/refs, react/no-find-dom-node */
	if (navItemRef.current) {
		const NavItem = ReactDOM.findDOMNode(navItemRef.current)
		if (isMatched) {
			NavItem.classList.add('active')
		} else {
			NavItem.classList.remove('active')
		}
	}
	/* eslint-enable react-hooks/refs, react/no-find-dom-node */

	const handleCloseDropdown = () => {
		if (isDisabled) {
			return
		}
		new Promise(res => {
			dropDownCloseTimer.current = setTimeout(res, 250)
		}).then(() => {
			setDisplayDropdown(false)
		})
	}
	const handleOpenDropdown = () => {
		if (isDisabled) {
			return
		}
		if (dropDownCloseTimer.current) {
			clearTimeout(dropDownCloseTimer.current)
			dropDownCloseTimer.current = null
		}
		setDisplayDropdown(true)
	}


	return (
		<OptionenNavConteiner onMouseLeave={handleCloseDropdown} onMouseOver={handleOpenDropdown}
			isMatched={isMatched} isDisabled={isDisabled}>
			<Settings/>
			{t('options_section.caption')}
			{displayDropdown &&
				<NavDropDown>
					<NavBarItem noDisplayAsLink={true} link='optionen'
						name={t('options_section.strings.business')} exact
						onClick={handleCloseDropdown}/>
					<NavBarItem noDisplayAsLink={true} link='optionen/kasse'
						name={t('common.fields.cash_registers')} onClick={handleCloseDropdown}/>
					<NavBarItem noDisplayAsLink={true} link='optionen/restaurantDesigner'
						name={t('options_section.sub_sections.restaurant_designer')}
						onClick={handleCloseDropdown}/>
					<NavBarItem noDisplayAsLink={true} link='optionen/kasse-global'
						name={t('options_section.sub_sections.cash_register_global')}
						onClick={handleCloseDropdown}/>
					<NavBarItem noDisplayAsLink={true} link='optionen/automation' name={t('options_section.sub_sections.automation')} onClick={handleCloseDropdown}/>
					<NavBarItem noDisplayAsLink={true}
						action={() => window.open('https://help.hssoft.com', '_blank')}
						name={t('options_section.sub_sections.help_center')}
						onClick={handleCloseDropdown}/>
				</NavDropDown>
			}
		</OptionenNavConteiner>
	)
}

export default withRouter(NavComponent)
